import styled from 'styled-components';
import { GlobalStyle } from './layout-frame';

const Page = styled.div``;

const Index = (props) => {
  const { children } = props;
  return (
    <>
      <script
        dangerouslySetInnerHTML={{
          __html: `
          var inPcClient=true;
          `,
        }}
      ></script>
      <Page>
        <GlobalStyle></GlobalStyle>
        {children}
      </Page>
    </>
  );
};
export const getInitialProps = () => {
  return {
    hasHeader: false,
    hasFooter: false,
  };
};

export default Index;
